export default __webpack_public_path__ + "static/media/ic_copy_16.fafdf331.svg";